import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import htmlEncode from 'js-htmlencode';
import { Button, Progress } from 'semantic-ui-react';
const customStylesDesk = {
  content: {
    top: '40%',
    left: '50%',
    width: '700px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};
const customStylesMobile = {
  top: '40%',
  left: '40%',
  width: '350px',
  right: 'auto',
  bottom: 'auto',
  border: '1px solid grey',
  borderRadius: 0,
  transform: 'translate(-50%, -50%)',
};

const customStyles = function() {
  if (window.innerWidth < 768) {
    return customStylesMobile;
  } else {
    return customStylesDesk;
  }
};

const SecondTitle = styled.p`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 40px;
  text-align: center;
  text-transform: none;
  font-family: Arial;
  font-weight: normal;
  font-size: 1.4em;
`;

const Title = styled.h3`
  margin: 30px 10px 20px 10px;
  font-size: 1.8em;
  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;
const Content = styled.div`
  display: block;
  width: 100%;
  // margin: auto;
  text-align: center;
`;

const CloseIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  background-image: url(/img/close.png);
  width: 30px;
  height: 30px;
  background-repeat: round;
  opacity: 0.3;
  cursor: pointer;
`;

const Input = styled.input`
  width: 100%;
  max-width: 450px;
  margin: 8px 0 0 0;
  line-height: 2.5;
  border: ${props =>
    props.valid.length > 0 && props.valid.indexOf(props.id) !== -1
      ? '1px solid #ff0000'
      : '1px solid #000'};
  color: #000;
  padding-left: 5px;
  padding-right: 5px;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box;
  font-size: 1.2em;
  background-color: transparent;
  ::placeholder {
    color: #000;
    opacity: 1; /* Firefox */
  }
  @media (max-width: 768px) {
    font-size: 0.7em;
    width: 80%;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 300px;
  max-width: 450px;
  margin: 8px 0 0 0;
  border: ${props =>
    props.valid.length > 0 && props.valid.indexOf(props.id) !== -1
      ? '1px solid #ff0000'
      : '1px solid #000'};
  color: #000;
  padding-left: 5px;
  padding-right: 5px;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box;
  font-size: 1.2em;
  background-color: transparent;
  ::placeholder {
    color: #000;
    opacity: 1; /* Firefox */
  }
  @media (max-width: 768px) {
    font-size: 0.7em;
    min-height: 200px;
    width: 80%;
  }
`;

const Note = styled.p`
  margin-top: 0px;
  font-family: Arial;
  font-size: 0.67em;
  font-style: italic;
  color: grey;
  @media (max-width: 768px) {
    font-size: 0.5em;
  }
`;

const ActionButton = styled.button`
font-size:1.2em;
  // width: ${props => (props.width ? props.width : '20%')};
  border-radius: 5px;
  background-color: #134884;
  color: #fff;
  border: #134884;
  padding:0 10px 0 10px;
  margin-top: 20px;
  line-height: 1.7;
  float: right;
  &:hover {
    outline: none;
    background-color: #07284c;
  }
  &:focus {
    outline: none;
    background-color: #07284c;
  }
`;

const FileTitle = styled.span`
  font-size: 1.2em;
  line-height: ${props => (props.isIE ? 'auto' : 2.5)};
  padding-right: 5px;
  position: absolute;
  color: ${props => (props.invalid ? '#f00' : 'auto')};
  transform: ${props =>
    props.isIE ? 'translateY(30%)' : 'translateX(-100%) translateY(30%)'};
  @media (max-width: 768px) {
    font-size: 0.7em;
  }
`;

const ErrorText = styled.span`
  color: #f00;
  font-size: 1.2em;
  line-height: ${props => (props.isIE ? 'auto' : 2)};
  position: absolute;
  transform: translateY(50%);
  padding-left: 5px;
  @media (max-width: 768px) {
    font-size: 0.7em;
  }
`;
Modal.setAppElement('#modal');

export default class ModalPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notes: '',
      email: '',
      valid: [],
      open: false,
    };
  }

  componentWillReceiveProps(newprops, oldprops) {
    this.setState({ open: newprops.open });
  }

  triggerAction() {
    const { actionFn } = this.props;
    const valid = this.validState();
    this.setState({ valid });
    if (valid.length === 0) {
      const button = document.getElementById('downloadPDF');
      button.innerHTML =
        'download PDF <i class="fa fa-spinner" aria-hidden="true"></i>';
      actionFn(this.state);
    }
  }

  updateState(e) {
    const value = e.target.value;
    const key = e.target.id;
    this.setState({ [key]: htmlEncode(value) });
  }

  validState() {
    const { notes, email } = this.state;
    //TODO: valid user email info
    let res = [];
    if (!this.validateEmail(email)) res.push('email');
    // if (!name) res.push('name');
    return res;
  }
  validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }

  handleCloseModal = () => {
    this.setState({
      notes: '',
      email: '',
      valid: [],
      open: false,
    });
    this.props.closeModal();
  };

  capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  render() {
    const { valid } = this.state;
    const { closeModal, options } = this.props;
    const { open } = this.state;
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    return (
      <Modal
        onRequestClose={this.handleCloseModal}
        isOpen={open}
        style={customStyles()}
        contentLabel="Example Modal"
      >
        <Content>
          <CloseIcon onClick={this.handleCloseModal} />
          <Title>Download Specs (PDF)</Title>
          {options &&
            options.map(op =>
              <div key={op.label}>
                <FileTitle
                  invalid={valid.length > 0 && valid.indexOf(op.value) !== -1}
                  isIE={isIE}
                >
                  {op.label === 'email'
                    ? '*' + this.capitalizeFirstLetter(op.label)
                    : this.capitalizeFirstLetter(op.label)}
                </FileTitle>
                {op.label === 'email'
                  ? <Input
                      onBlur={this.updateState.bind(this)}
                      id={op.value}
                      key={op.value}
                      valid={valid}
                    />
                  : <TextArea
                      onBlur={this.updateState.bind(this)}
                      id={op.value}
                      key={op.value}
                      valid={valid}
                    />}

                {valid.length > 0 && valid.indexOf(op.value) !== -1
                  ? <ErrorText isIE={isIE}>
                      {' '}*Invalid {op.value}
                    </ErrorText>
                  : ''}
              </div>
            )}
          {/* <Note>
            Email address will be used for data collection only and will not be
            shared.
          </Note> */}

          <Button
            style={{ float: 'right', marginTop: '10px' }}
            id="downloadPDF"
            onClick={this.triggerAction.bind(this)}
          >
            download PDF
          </Button>
        </Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Modal.js